import OBTSplitButton, { ButtonTheme, ButtonType } from './OBTSplitButton';

export default OBTSplitButton;
export { ButtonTheme, ButtonType };
